var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('red-envelope-entrance',{style:({width: _vm.autoWidth ? '100%' : null}),attrs:{"red-envelope-data":_vm.redEnvelopeData,"custom-img-config":_vm.customImgConfig,"status":_vm.status},on:{"open":_vm.handleEntranceClick}})}
var staticRenderFns = []

export { render, staticRenderFns }